import React from "react";
import ReactApexChart from "react-apexcharts";

export default function BarChart({ title,subtitle, name, data, categories }) {
  const series = [
    {
      name: name,
      data: data,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    // ✅ Set bar color here
    colors: ["#6366F1"], // Indigo

    dataLabels: { enabled: false },

    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "50%",
      },
    },
    xaxis: {
      categories: categories,
    },
    // ✅ Prefix ₹ on Y-axis
    yaxis: {
      labels: {
        formatter: (value) => `₹${value}`,
      },
    },
    // ✅ Prefix ₹ in tooltip popup
    tooltip: {
      y: {
        formatter: (val) => `₹${val}`,
      },
    },
    grid: {
      borderColor: "#e5e7eb", // Tailwind slate-200
    },
  };
  return (
    <div className=" bg-white dark:bg-slate-900 p-4 rounded-2xl shadow-md w-120">
      <h1 className="text-md font-semibold mb-2 text-slate-700 dark:text-slate-200">
        {title}
      </h1>
      <span className="text-xs font-semibold mb-2 text-slate-700 dark:text-slate-400">
        {subtitle}
      </span>

      <ReactApexChart
        options={options}
        series={series}
        type={"bar"}
        height={300}
        width={400}
      />
    </div>
  );
}
